

import React, { memo } from 'react';
import { RadioGroup, RadioButton, LabelWrapper } from '../../../ui-kit';








function BulkActionOptions(props) {
  const { onChange, showEditLabel, add, remove } = props;

  return (
    <LabelWrapper divContainer label="Bulk Actions">
      <RadioGroup onChange={onChange} onlyOneSelected>
        <RadioButton key="bulk_action_option_add" value="add" selected={add}>
          {`Add New ${showEditLabel ? 'Labels' : 'Tags'}`}
        </RadioButton>
        <RadioButton key="bulk_action_option_remove" value="remove" selected={remove}>
          {`Remove ${showEditLabel ? 'Labels' : 'Tags'}`}
        </RadioButton>
      </RadioGroup>
    </LabelWrapper>);

}

export default memo(BulkActionOptions);